import React, { useState } from "react";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import '@fortawesome/fontawesome-free/css/all.min.css';
import './myConnectSidebar.css';
import ConnectTable from "./connectTable";
import { postDetails, postMultipartDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import { PlusCircleFill } from "react-bootstrap-icons";
import { Modal, Button, Form } from "react-bootstrap";
import encrypt from "../../utils/helpers/encrypt";

const MyConnectSidebar: React.FunctionComponent = () => {
    const [showAddModal, setShowAddModal] = useState(false);
    const [title, setTitle] = useState("");
    const [isFolder, setIsFolder] = useState(false); // Track whether it's a folder or item
    const [imageFile, setImageFile] = useState<File | null>(null); // State for file input
  const [titleError, setTitleError] = useState<string | null>(null); // State for title validation
    const [imageFileError, setImageFileError] = useState<string | null>(null); // State for file validation
    const handleCloseModal = () => setShowAddModal(false);
    const handleOpenModal = () => setShowAddModal(true);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null;
        setImageFile(file);
    };

    // const handleSubmit = async () => {
    //     if (!title) return; // Basic validation

    //     const formData = new FormData();

    //     const payload = {
    //         title,
    //         is_folder: isFolder ? 1 : 0 // Convert boolean to integer
    //     };
    //     formData.append('data', encrypt(payload)); // Convert boolean to string for API
    //     if (imageFile) {
    //         formData.append('mediafiles', imageFile);
    //     }

    //     try {
    //         const response = await postMultipartDetails(APIList.EDIT_DATA, formData);
    //         console.log(response)
    //         if (response.statusCode === 200) {
    //             console.log("Data added successfully.");
    //             // Optionally, you can refresh the data here or handle success feedback
    //         } else {
    //             console.error("Failed to add data:", response.message);
    //         }
    //     } catch (error) {
    //         console.error("Error adding data:", error);
    //     } finally {
    //         handleCloseModal();
    //     }
    // };

    return (
        <LayoutContainer title="dashboard">
            <div className="page-header d-flex align-items-center justify-content-left dashboard-container h-100">
                <h2>
                    <i className="page-header-icon fa fa-flask"></i>
                    My Connect
                </h2>
                {/* <button className="add-btn" onClick={handleOpenModal}>
                    <PlusCircleFill />
                    Add Data
                </button> */}
            </div>
            <div className="connect-table">
            <ConnectTable />
            </div>
           

            <Modal show={showAddModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Add New Data</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formTitle">
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter title"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group controlId="formIsFolder">
                            <Form.Check
                                type="checkbox"
                                label="Is Folder"
                                checked={isFolder}
                                onChange={(e) => setIsFolder(e.target.checked)}
                            />
                        </Form.Group>
                        <Form.Group controlId="formFile">
                            <Form.Label>Image File</Form.Label>
                            <Form.Control
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Close
                    {/* </Button> */}
                    {/* <Button variant="primary" onClick={handleSubmit}> */}
                      
                    </Button>
                </Modal.Footer>
            </Modal>
        </LayoutContainer>
    );
};

export default MyConnectSidebar;
